import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";

export default function validate(values) {
  return validator(values, v => {
    const totalQty =
      parseInt(values.quantity, 10) +
      parseInt(values.remaining_quantity, 10) -
      1;
    const maxQty = totalQty > 0 ? totalQty : values.remaining_quantity;

    if (values.quantity <= 0) {
      v.validate("quantity").satisfies(rules.isGreaterThan(0));
    } else {
      v.validate("quantity").satisfies(rules.isBetween(1, maxQty));
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/SplitInventory/validate.js